import shippingAiAssistedCode from "./shipping-ai-assisted-code-without-the-slop";
import evalsPost from "./what-is-your-eval-suite-actually-measuring";
import productionEval from "./evals-tell-you-what-you-designed-for-data-tells-you-the-rest";
import contextWindowFull from "./your-context-window-is-full-now-what";
import verificationGap from "./writing-code-got-faster-making-sure-it-works-didnt";
import contextIsArchitecture from "./how-you-structure-context-is-how-you-structure-behavior";

export const POST_CONTENT = {
  "shipping-ai-assisted-code-without-the-slop": shippingAiAssistedCode,
  "what-is-your-eval-suite-actually-measuring": evalsPost,
  "evals-tell-you-what-you-designed-for-data-tells-you-the-rest": productionEval,
  "your-context-window-is-full-now-what": contextWindowFull,
  "writing-code-got-faster-making-sure-it-works-didnt": verificationGap,
  "how-you-structure-context-is-how-you-structure-behavior": contextIsArchitecture,
};
